import * as React from 'react'

const IAIcon: React.FC<React.SVGProps<SVGElement>> = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="#627680"
      d="M22 2v18.085H11.333L5.564 23v-2.915H2V2zM7.164 20.398l3.787-1.913h9.45V3.6H3.6v14.885h3.564z"
    ></path>
    <path fill="#627680" d="M16.514 7v7h-1.6V7zM8.714 11.2h3v1.6h-3z"></path>
    <path fill="#627680" d="m11.215 7 2.187 7h-1.676L10.45 9.92 9.176 14H7.5l2.187-7z"></path>
  </svg>
)

export default IAIcon
